<template>
  <div class="investFunds">
    <v-data-table
      v-model="selectedFunds"
      :headers="headers"
      :items="investFunds"
      :items-per-page="-1"
      item-key="portfolioId"
      class="fundsTable"
      show-select
      dense
      @click:row="onRowClick"
    >
      <template v-slot:top>
        <v-dialog v-model="showDialog" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="text-h5">Edit prices</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="editedFund.bid"
                      label="Bid price"
                      type="number"
                      step="0.00001"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="editedFund.offer"
                      label="Offer price"
                      type="number"
                      step="0.00001"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" outlined @click="onCancel"> Cancel </v-btn>
              <v-btn color="primary" depressed @click="onSave"> Save </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template v-slot:[`item.bid`]="{ item }">
        <span>{{ Number(item.bid).toFixed(5) }}</span>
      </template>
      <template v-slot:[`item.offer`]="{ item }">
        <span>{{ Number(item.offer).toFixed(5) }}</span>
      </template>
    </v-data-table>
    <v-alert v-if="hasMissingPrices" type="warning" outlined dense style="grid-column: 1 / -1; max-width: 960px;"
      >Funds must have a price set on the investment date</v-alert>
  </div>
</template>

<script>
export default {
  name: 'InvestFunds',
  props: { investFunds: Array, reportList: Array },

  data() {
    return {
      loading: false,
      headers: [
        { text: 'Manager', value: 'manager' },
        { text: 'Fund', value: 'fund' },
        { text: 'Bid', value: 'bid', align: 'end' },
        { text: 'Offer', value: 'offer', align: 'end' },
      ],
      selectedFunds: [],
      editedFund: {},
      showDialog: false,
    };
  },

  watch: {
    investFunds() {
      if (this.investFunds && this.investFunds.length) {
        this.selectedFunds = [...this.investFunds];
        this.selectedFunds.forEach((fund) => (fund.selected = true));
      }
    },
    selectedFunds() {
      const selectedIds = this.selectedFunds.map((fund) => fund.portfolioId);
      this.investFunds.forEach((fund) => {
        const a = selectedIds.includes(fund.portfolioId);
        if (a) {
          fund.selected = true;
        } else {
          fund.selected = false;
        }
      });
    },
  },

  mounted() {
    if (this.investFunds && this.investFunds.length) {
      this.selectedFunds = [...this.investFunds];
      this.selectedFunds.forEach((fund) => (fund.selected = true));
    }
  },

  computed: {
    hasMissingPrices() {
      return this.investFunds && this.investFunds.some((fund) => fund.selected && (!fund.bid || !fund.offer));
    },
  },

  methods: {
    onRowClick(item) {
      if (item) {
        this.editedFund = { ...item };
        this.showDialog = true;
      }
    },

    onCancel() {
      this.showDialog = false;
      this.editedFund = {};
    },

    onSave() {
      this.showDialog = false;
      this.investFunds.forEach((fund) => {
        if (fund.portfolioId === this.editedFund.portfolioId) {
          fund.offer = this.editedFund.offer;
          fund.bid = this.editedFund.bid;
        }
      });
    },
  },
};
</script>

<style scoped>
.fundsTable.v-data-table {
  max-width: 960px;
}
.investFunds {
  display: grid;
  grid-template-columns: repeat(2, auto);
  column-gap: 40px;
}
.reportsTable.v-data-table {
  max-width: 300px;
}

.v-data-table__selected tbody tr {
  cursor: default;
}
</style>
